import React, { Component } from 'preact'
import {
  getAllMasks,
  getCountries, getFavoriteMasks,
  getMaskByName
} from './model'
import styles from './style.styl'
import formStyles from '../form/style.styl'
import { cc } from '../../utils'
import IMask from 'imask'

class PhoneInput extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectVisible: false,
      value: '',
      visible: false,
      countries: [],
      imask: null,
      selected: false,
      selectedLength: 0,
      mask: {
        mask: getAllMasks(),
        dispatch: function (appended, dynamicMasked) {
          if (this.state.selected) return dynamicMasked.currentMask

          const value = (dynamicMasked.value + appended).replace(/\D/g, '')
          const favorites = getFavoriteMasks()

          const filtered = dynamicMasked.compiledMasks.filter(function (m) {
            return value.indexOf(m.startsWith) === 0 || m.startsWith.indexOf(value) === 0
          }).filter(m => {
            return m.mask.replace(/\D/g, '').length >= value.replace(/\D/g, '').length
          })
            .sort((a, b) => {
              return favorites.indexOf(b.mask) - favorites.indexOf(a.mask) || a.mask.replace(/\D/g, '').length - b.mask.replace(/\D/g, '').length
            })

          return filtered[0] || dynamicMasked.currentMask
        }.bind(this)
      }
    }
    this.ref = React.createRef()
    this.wrapref = React.createRef()
  }

  componentDidMount () {
    if (this.ref.current) {
      const mask = IMask(this.ref.current, this.state.mask)
      this.setState({ ...this.state, imask: mask })

      window.addEventListener('focusin', (e) => {
        if (this.wrapref.current && !this.wrapref.current.contains(e.target)) {
          this.setState({ ...this.state, visible: false })
        }
      })
      window.addEventListener('click', (e) => {
        if (this.wrapref.current && !this.wrapref.current.contains(e.target)) {
          this.setState({ ...this.state, visible: false })
        }
      })
      window.addEventListener('touchend', (e) => {
        if (this.wrapref.current && !this.wrapref.current.contains(e.target)) {
          this.setState({ ...this.state, visible: false })
        }
      })

      this.ref.current.addEventListener('input', this.handleChange.bind(this))
    }
  }

  handleChange (e) {
    const currentMask = this.state.imask.masked.currentMask.mask

    this.props.handleChange({ value: e.target.value, isValid: e.target.value.length === currentMask.length })

    this.setState((prev) => ({
      ...prev,
      countries: getCountries(e.target.value),
      selected: prev.selected ? !(prev.selectedLength > e.target.value.length && getCountries(e.target.value).length > 1) : false,
      selectedLength: (prev.selectedLength > e.target.value.length && getCountries(e.target.value).length > 1) ? 0 : prev.selectedLength,
      visible: getCountries(e.target.value).length > 1 }))
  }

  render (props, state, context) {
    // if (this.ref && this.ref.current) {
    //   setTimeout(() => {
    //     this.state.imask.alignCursor()
    //     const length = this.ref.current.value.length
    //     this.ref.current.setSelectionRange(length, length)
    //   }, 10)
    // }

    if (props.disabled) {
      this.state.imask.value = ''
    }
    return (
      <div id={'phone-input'} ref={this.wrapref} className={cc(styles.wrap, formStyles.formFieldBox)}>
        <input
          key={'48376523256256'}
          disabled={props.disabled}
          autoComplete='off'
          name={'phone'}
          type={'tel'}
          placeholder={'phone'}
          className={formStyles.formFieldPhone}
          onFocus={() => {
            if (this.state.imask.value === '' || this.state.imask.value === '+') {
              this.state.imask.value = '+'
              this.setState({ ...this.state, visible: true, countries: getCountries() })
            }
          }}
          ref={this.ref}
        />
        <div
          className={props.isValid
            ? formStyles.formFieldIndicatorValid
            : formStyles.formFieldIndicator
          }
        />
        {this.state.visible && this.state.countries.flat().length > 1 && (
          <div className={styles.dropdown}>
            <div className={styles.dropdownInner}>
              {this.state.countries.map((block, blockIndex, blocks) => {
                if (block.length < 1) return null
                return <div className={styles.block}>
                  {
                    block.map((item, itemIndex) => {
                      return (
                        <div className={cc(styles.item,
                          (blockIndex === 0 && itemIndex === 3) ? styles.itemDesk : '',
                          (blockIndex === 0 && itemIndex === 4) ? styles.itemDesk : '',
                          (blockIndex === 1 && itemIndex === 0) && blocks[0].length > 3 ? styles.itemMobile : '',
                          (blockIndex === 1 && itemIndex === 1) && blocks[0].length > 4 ? styles.itemMobile : ''
                        )} onClick={() => {
                          const cMask = getMaskByName(item.name, item.code)
                          const foundMask = this.state.imask.masked.compiledMasks.find(mask => mask.mask === cMask.mask && mask.startsWith === cMask.startsWith)
                          this.state.imask.masked.currentMask = foundMask
                          this.setState(prev => ({ ...prev, selected: true, selectedLength: item.code.length }))
                          this.state.imask.value = item.code
                          this.ref.current.focus()
                          this.state.imask.alignCursor()
                          this.ref.current.setSelectionRange(item.code.length, item.code.length)
                        }}>
                          <span>{item.name}</span>
                          <span>{item.code}</span>
                        </div>
                      )
                    })
                  }
                  {blockIndex === 0 && blocks[0].length > 0 && blocks[1].length > 0 && <div className={styles.splitter} /> }
                </div>
              })}
            </div>
          </div>
        )
        }
      </div>
    )
  }
}

export default PhoneInput



// WEBPACK FOOTER //
// ./components/phone-input/index.js